export default function Team() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="inline-block bg-cyan-100 text-cyan-700 px-4 py-2 rounded-full text-sm font-semibold mb-6">
            OUR TEAM
          </div>
          <h2 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Meet the People Behind Our Success
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto leading-relaxed">
            Our dedicated team of pharmaceutical professionals, healthcare experts, and support staff work tirelessly to ensure the highest quality products and services reach those who need them most.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-16">
          <div>
            <div className="rounded-3xl overflow-hidden shadow-2xl">
              <img
                src="/assets/AboutTeam.jpg"
                alt="Our Team"
                className="w-full h-full object-cover object-center"
              />
            </div>
          </div>

          <div>
            <h3 className="text-3xl font-bold text-gray-900 mb-6">
              Expertise You Can Trust
            </h3>
            <p className="text-gray-600 text-base leading-relaxed mb-4">
              Our team comprises experienced pharmaceutical professionals with decades of combined expertise in cardiovascular and diabetic care. Each member brings unique skills and knowledge that contribute to our mission of delivering excellence.
            </p>
            <p className="text-gray-600 text-base leading-relaxed mb-6">
              From quality assurance specialists to regulatory experts, from supply chain managers to customer service representatives, every team member plays a vital role in ensuring our products meet the highest standards.
            </p>

            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mr-4">
                  <i className="ri-user-star-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">50+</div>
                  <div className="text-sm text-gray-600">Dedicated Professionals</div>
                </div>
              </div>

              <div className="flex items-center">
                <div className="w-12 h-12 flex items-center justify-center bg-cyan-100 rounded-lg mr-4">
                  <i className="ri-graduation-cap-line text-cyan-600 text-xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">100+</div>
                  <div className="text-sm text-gray-600">Years Combined Experience</div>
                </div>
              </div>

              <div className="flex items-center">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg mr-4">
                  <i className="ri-medal-line text-teal-600 text-xl"></i>
                </div>
                <div>
                  <div className="text-2xl font-bold text-gray-900">15+</div>
                  <div className="text-sm text-gray-600">Industry Certifications</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="bg-gradient-to-br from-teal-600 to-cyan-600 rounded-3xl p-12 text-center">
          <h3 className="text-4xl font-bold text-white mb-4">
            Join Our Growing Team
          </h3>
          <p className="text-white/90 text-lg mb-8 max-w-2xl mx-auto">
            We're always looking for talented individuals who share our passion for pharmaceutical excellence and patient care.
          </p>
          <button className="bg-white text-teal-600 px-8 py-3 rounded-full font-semibold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
            View Career Opportunities
            <i className="ri-arrow-right-line ml-2"></i>
          </button>
        </div>
      </div>
    </section>
  );
}
